<template>
  <div class="card" style="margin-bottom: 10px">
    <div class="card-body">
      <div class="row">
        <div style="display: flex; justify-content: space-between; gap: 10px">
          <p style="margin: 10px; font-weight: bold">
            <i style="margin-right: 10px" class="fas fa-list"></i> LISTADO DE
            DISTRIBUIDORES
          </p>
          <Skeletor
            v-if="loading"
            :shimmer="true"
            height="20"
            width="100%"
            style="margin: auto"
          />
          <div v-else @click="refresh" style="display: flex; gap: 10px">
            <button
              class="btn btn-primary"
              @click="addDistributor"
              style="width: 200px"
            >
              Agregar Distribuidor <i class="fas fa-plus"></i>
            </button>
            <button
              class="btn btn-success"
              @click="downloadExcel"
              style="width: 150px"
              :disabled="filteredDistributors.length === 0"
            >
              <i class="fas fa-file-excel"></i> Excel
            </button>
            <i
              style="cursor: pointer; margin: auto"
              class="fas fa-sync text-sm opacity-10"
            ></i>
          </div>
        </div>

        <!-- Filter Section -->
        <div v-if="!loading && !notAllow" class="row mb-3">
          <div class="col-md-4">
            <label for="addedByFilter" class="form-label"
              >Filtrar por Agregado:</label
            >
            <select
              id="addedByFilter"
              class="form-control"
              v-model="addedByFilter"
              @change="applyFilter"
            >
              <option value="">Todos</option>
              <option value="Maritza Quevedo">Maritza Quevedo</option>
              <option value="Diego Bejarano">Diego Bejarano</option>
              <option value="PlanPro">PlanPro</option>
            </select>
          </div>
          <div class="col-md-4">
            <label for="statusFilter" class="form-label"
              >Filtrar por Estado:</label
            >
            <select
              id="statusFilter"
              class="form-control"
              v-model="statusFilter"
              @change="applyFilter"
            >
              <option value="">Todos</option>
              <option value="active">Activo</option>
              <option value="inactive">Inactivo</option>
            </select>
          </div>
        </div>
      </div>

      <div
        v-if="loading"
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="padding: 0px"
      >
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <table class="table tablesorter">
              <thead class="thead-light">
                <tr>
                  <th>
                    <Skeletor :shimmer="true" height="10" width="100%" />
                  </th>
                  <th>
                    <Skeletor :shimmer="true" height="10" width="100%" />
                  </th>
                  <th>
                    <Skeletor :shimmer="true" height="10" width="100%" />
                  </th>
                  <th>
                    <Skeletor :shimmer="true" height="10" width="100%" />
                  </th>
                  <th>
                    <Skeletor :shimmer="true" height="10" width="100%" />
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="i in 3" :key="i">
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                  <td>
                    <Skeletor :shimmer="true" height="20" width="100%" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div v-else-if="notAllow" class="row">
        <div
          class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
          align="center"
        >
          <img style="width: 100px" src="/img/caution.svg" />
          <p style="margin-top: 10px; font-size: 14px">
            Tu rol no te permite utilizar la siguiente funcionalidad.
          </p>
        </div>
      </div>

      <DataTable
        v-else
        :columns="columns"
        :options="options"
        :data="filteredDistributors"
        class="table tablesorter"
        width="100%"
      >
        <thead>
          <tr>
            <th>Creación</th>
            <th>Empresa</th>
            <th>RUC</th>
            <th>Dirección</th>
            <th>Ciudad</th>
            <th>Teléfono</th>
            <th>Tipo</th>
            <th>Agregado</th>
            <th>Tabla ARPU</th>
            <th>Usuarios</th>
            <th>Activo</th>
            <!-- <th>Total Ventas</th> -->
            <th>Acciones</th>
          </tr>
        </thead>
      </DataTable>
    </div>
  </div>

  <!-- Add Distributor Modal -->
  <VueFinalModal
    v-model="showAddModal"
    :esc-to-close="false"
    :click-to-close="false"
    :prevent-click="false"
    class="modal-container"
    content-class="modal-content4"
  >
    <div class="modal-header">
      <h5 class="modal-title">Agregar Distribuidor</h5>
      <button
        type="button"
        class="btn-close"
        @click="showAddModal = false"
      ></button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label for="ruc">RUC de la Empresa</label>
        <div style="display: flex; gap: 10px; height: fit-content">
          <input
            type="text"
            class="form-control"
            id="ruc"
            v-model="rucNumber"
            placeholder="Ingrese el RUC"
            :disabled="loadingRuc"
          />
          <button
            class="btn btn-primary"
            @click="fetchCompanyByRuc"
            style="display: flex; align-items: center; gap: 10px"
            :disabled="loadingRuc || !rucNumber"
          >
            <i class="fas fa-search" v-if="!loadingRuc"></i>
            <i class="fas fa-spinner fa-spin" v-else></i>
            Buscar
          </button>
        </div>
      </div>

      <div
        v-if="companyInfo.companyName && companyInfo.address"
        class="company-info mt-4"
      >
        <h6>Información de la Empresa</h6>
        <div class="info-item"><strong>RUC:</strong> {{ this.rucNumber }}</div>
        <div class="info-item">
          <strong>Razón Social:</strong> {{ companyInfo.companyName }}
        </div>
        <div class="info-item">
          <strong>Dirección:</strong> {{ companyInfo.address }}
        </div>
        <div class="info-item">
          <strong>Ciudad:</strong>
          <select class="form-control" v-model="companyInfo.city">
            <option value="null">Seleccione una ciudad</option>
            <option v-for="city in cities" :key="city" :value="city">
              {{ city }}
            </option>
          </select>
        </div>
        <div class="info-item">
          <strong>Teléfono:</strong>
          <MazPhoneNumberInput
            type="tel"
            default-country-code="EC"
            style="width: 100%"
            no-flags
            no-example
            required
            show-code-on-list
            size="sm"
            v-model="companyInfo.phone"
            @update:value="companyInfo.phone = $event"
            :translations="{
              countrySelector: {
                placeholder: 'Código',
                error: 'Elija un pais',
              },
              phoneInput: {
                placeholder: 'Nro. celular',
                example: 'Ejemplo:',
              },
            }"
          />
        </div>
        <div class="info-item">
          <strong>Tipo:</strong>
          <select class="form-control" v-model="companyInfo.type" required>
            <option value="">Seleccione un tipo</option>
            <option value="promoter">Promotor (Actividad comercial)</option>
            <option value="enterprise">
              Cadena de Tiendas (Empresa grande)
            </option>
          </select>
        </div>
        <div class="info-item">
          <strong>Tabla ARPU:</strong>
          <select class="form-control" v-model="companyInfo.arpuTableId">
            <option
              v-for="table in arpuTables"
              :key="table.id"
              :value="table.id"
            >
              {{ table.name }}{{ table.isDefault ? " (default)" : "" }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        @click="showAddModal = false"
      >
        Cancelar
      </button>
      <button
        type="button"
        class="btn btn-primary"
        @click="saveDistributor"
        :disabled="!isFormValid || loading"
      >
        Guardar
      </button>
    </div>
  </VueFinalModal>

  <!-- Edit Distributor Modal -->
  <VueFinalModal
    v-model="showEditModal"
    :esc-to-close="false"
    :click-to-close="false"
    :prevent-click="false"
    class="modal-container"
    content-class="modal-content4"
  >
    <div class="modal-header">
      <h5 class="modal-title">Editar Distribuidor</h5>
      <button
        type="button"
        class="btn-close"
        @click="showEditModal = false"
      ></button>
    </div>
    <div class="modal-body">
      <div v-if="loadingDistributorDetails">
        <div class="text-center">
          <i class="fas fa-spinner fa-spin"></i> Cargando información...
        </div>
      </div>
      <div v-else>
        <div class="form-group">
          <label for="editRuc">RUC de la Empresa</label>
          <input
            type="text"
            class="form-control"
            id="editRuc"
            v-model="selectedDistributor.ruc"
            disabled
          />
        </div>

        <div class="company-info mt-4">
          <h6>Información de la Empresa</h6>
          <div class="info-item">
            <strong>Razón Social:</strong>
            <input
              type="text"
              class="form-control"
              v-model="selectedDistributor.companyName"
              disabled
            />
          </div>
          <div class="info-item">
            <strong>Dirección:</strong>
            <input
              type="text"
              class="form-control"
              v-model="selectedDistributor.address"
              disabled
            />
          </div>
          <div class="info-item">
            <strong>Ciudad:</strong>
            <select class="form-control" v-model="selectedDistributor.city">
              <option value="null">Seleccione una ciudad</option>
              <option v-for="city in cities" :key="city" :value="city">
                {{ city }}
              </option>
            </select>
          </div>
          <div class="info-item">
            <strong>Teléfono:</strong>
            <MazPhoneNumberInput
              type="tel"
              default-country-code="EC"
              style="width: 100%"
              no-flags
              no-example
              required
              show-code-on-list
              size="sm"
              v-model="selectedDistributor.phone"
              @update:value="selectedDistributor.phone = $event"
              :translations="{
                countrySelector: {
                  placeholder: 'Código',
                  error: 'Elija un pais',
                },
                phoneInput: {
                  placeholder: 'Nro. celular',
                  example: 'Ejemplo:',
                },
              }"
            />
          </div>
          <div class="info-item">
            <strong>Agregado por:</strong>
            <select class="form-control" v-model="selectedDistributor.addedBy">
              <option value="">Seleccione una opción</option>
              <option value="Maritza Quevedo">Maritza Quevedo</option>
              <option value="Diego Bejarano">Diego Bejarano</option>
              <option value="PlanPro">PlanPro</option>
            </select>
          </div>
          <div class="info-item">
            <strong>Tipo:</strong>
            <select
              class="form-control"
              v-model="selectedDistributor.type"
              required
            >
              <option value="">Seleccione un tipo</option>
              <option value="promoter">Promotor (Actividad comercial)</option>
              <option value="enterprise">
                Cadena de Tiendas (Empresa grande)
              </option>
            </select>
          </div>
          <div class="info-item">
            <strong>Tabla ARPU:</strong>
            <select
              class="form-control"
              v-model="selectedDistributor.arpuTableId"
            >
              <option
                v-for="table in arpuTables"
                :key="table.id"
                :value="table.id"
              >
                {{ table.name }}{{ table.isDefault ? " (default)" : "" }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div style="display: flex; gap: 12px">
        <button
          type="button"
          class="btn btn-danger"
          style="font-size: 12px !important"
          @click="
            softDeleteDistributor(
              selectedDistributor.companyId,
              selectedDistributor.companyName,
            )
          "
          :disabled="loading"
        >
          <i class="fas fa-trash"></i> Eliminar
        </button>
        <button
          type="button"
          style="font-size: 12px !important"
          class="btn btn-secondary me-2"
          @click="showEditModal = false"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="btn btn-primary"
          style="font-size: 12px !important"
          @click="updateDistributor"
          :disabled="!isEditFormValid || loading"
        >
          Guardar Cambios
        </button>
      </div>
    </div>
  </VueFinalModal>

  <!-- Add Distributor Manager Modal (Enterprise: Jefe/Vendedor/Manager | Otros: Administrador) -->
  <VueFinalModal
    v-model="showManagerModal"
    :esc-to-close="false"
    :click-to-close="false"
    :prevent-click="false"
    class="modal-container"
    content-class="modal-content4"
  >
    <div class="modal-header">
      <h5 class="modal-title">
        {{ isEnterpriseDistributor ? 'Agregar (Jefe / Vendedor / Manager)' : 'Agregar Administrador de Distribuidor' }}
      </h5>
      <button
        type="button"
        class="btn-close"
        @click="showManagerModal = false"
      ></button>
    </div>
    <div class="modal-body">
      <div v-if="loadingDistributorDetails">
        <div class="text-center">
          <i class="fas fa-spinner fa-spin"></i> Cargando información...
        </div>
      </div>
      <div v-else>
        <template v-if="isEnterpriseDistributor">
          <div class="form-group mb-3">
            <label class="form-control-label">Rol</label>
            <select v-model="managerData.role" class="form-select" required>
              <option value="director">Jefe (Director)</option>
              <option value="supervisor">Supervisor</option>
              <option value="manager">Manager</option>
              <option value="salesRep">Vendedor (SalesRep)</option>
            </select>
          </div>
          <div class="form-group mb-3">
            <label class="form-control-label">Local (Branch)</label>
            <select
              v-if="managerBranchesList.length > 0"
              v-model="managerData.branch"
              class="form-select"
              required
            >
              <option value="">Seleccione un local</option>
              <option v-for="b in managerBranchesList" :key="b" :value="b">{{ b }}</option>
            </select>
            <input
              v-else
              type="text"
              class="form-control"
              v-model="managerData.branch"
              placeholder="Nombre del local"
              required
            />
            <small v-if="managerBranchesList.length === 0" class="text-muted">
              Escriba el nombre del local (ej. Tienda Centro)
            </small>
          </div>
          <div class="form-group mb-3">
            <label class="form-control-label">Ciudad (opcional)</label>
            <select
              v-if="managerCitiesList.length > 0"
              v-model="managerData.city"
              class="form-select"
            >
              <option value="">Seleccione una ciudad</option>
              <option v-for="c in managerCitiesList" :key="c" :value="c">{{ c }}</option>
            </select>
            <input
              v-else
              type="text"
              class="form-control"
              v-model="managerData.city"
              placeholder="Ej. Quito, Guayaquil"
            />
            <small v-if="managerCitiesList.length === 0" class="text-muted">
              Ciudades de la empresa aparecerán al tener usuarios
            </small>
          </div>
          <div class="form-group mb-3">
            <label class="form-control-label">Teléfono (*)</label>
            <MazPhoneNumberInput
              type="tel"
              default-country-code="EC"
              style="width: 100%"
              no-flags
              no-example
              show-code-on-list
              size="sm"
              v-model="managerData.phone"
              @update:value="managerData.phone = $event"
              :translations="{
                countrySelector: { placeholder: 'Código', error: 'Elija un pais' },
                phoneInput: { placeholder: 'Nro. celular', example: 'Ejemplo:' },
              }"
            />
          </div>
        </template>

        <div class="form-group">
          <label for="dni">{{ isEnterpriseDistributor ? 'Cédula (DNI)' : 'DNI del Administrador' }}</label>
          <div style="display: flex; gap: 10px; height: fit-content">
            <input
              type="text"
              class="form-control"
              id="dni"
              v-model="managerData.dni"
              placeholder="Ingrese la cédula"
              :disabled="loadingDni"
            />
            <button
              class="btn btn-primary"
              @click="fetchPersonByDni"
              style="display: flex; align-items: center; gap: 10px"
              :disabled="loadingDni || !managerData.dni"
            >
              <i class="fas fa-search" v-if="!loadingDni"></i>
              <i class="fas fa-spinner fa-spin" v-else></i>
              Buscar
            </button>
          </div>
        </div>

        <div
          v-if="managerData.names || managerData.lastnames"
          class="company-info mt-4"
        >
          <h6>Datos</h6>
          <div class="info-item"><strong>DNI:</strong> {{ managerData.dni }}</div>
          <div class="info-item" v-if="managerData.names">
            <strong>Nombre:</strong> {{ managerData.names }}
          </div>
          <div class="info-item" v-if="managerData.lastnames">
            <strong>Apellidos:</strong> {{ managerData.lastnames }}
          </div>
          <div class="info-item" v-if="isEnterpriseDistributor && managerData.phone">
            <strong>Teléfono:</strong> {{ managerData.phone }}
          </div>
          <div class="info-item" v-if="isEnterpriseDistributor">
            <strong>Local:</strong> {{ managerData.branch || '—' }}
          </div>
          <div class="info-item" v-if="isEnterpriseDistributor">
            <strong>Rol:</strong> {{ managerRoleLabel(managerData.role) }}
          </div>
        </div>

        <div class="company-info mt-3" v-if="selectedDistributorInfo">
          <p class="mb-1">
            <strong>Distribuidor:</strong>
            {{ selectedDistributorInfo.companyName }}
          </p>
          <p class="mb-0">
            <strong>RUC:</strong> {{ selectedDistributorInfo.ruc }}
          </p>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        @click="showManagerModal = false"
      >
        Cancelar
      </button>
      <button
        type="button"
        class="btn btn-primary"
        @click="saveDistributorManager"
        :disabled="!isManagerFormValid || loading"
      >
        Guardar
      </button>
    </div>
  </VueFinalModal>

  <!-- Company Profiles Modal -->
  <VueFinalModal
    v-model="showProfilesModal"
    :esc-to-close="false"
    :click-to-close="false"
    :prevent-click="false"
    class="modal-container"
    content-class="modal-content-profiles"
  >
    <div class="modal-header">
      <h5 class="modal-title">
        Usuarios de {{ selectedCompanyInfo.companyName }}
      </h5>
      <button
        type="button"
        class="btn-close"
        @click="showProfilesModal = false"
      ></button>
    </div>
    <div class="modal-body">
      <div v-if="loadingProfiles">
        <div class="text-center">
          <i class="fas fa-spinner fa-spin"></i> Cargando usuarios...
        </div>
      </div>
      <div v-else-if="companyProfiles.length === 0">
        <div class="text-center">
          <i
            class="fas fa-users"
            style="font-size: 3rem; color: #ccc; margin-bottom: 1rem"
          ></i>
          <p>No hay usuarios registrados en esta empresa.</p>
        </div>
      </div>
      <div v-else>
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Email</th>
                <th>DNI</th>
                <th>Rol</th>
                <th>Registrado</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="profile in companyProfiles" :key="profile.userId">
                <td>
                  {{
                    profile.displayName ||
                    profile.names + " " + profile.lastnames
                  }}
                </td>
                <td>{{ profile.email || "N/A" }}</td>
                <td>{{ profile.dni || "N/A" }}</td>
                <td>
                  <span
                    class="badge"
                    :class="{
                      'badge-primary': profile.role === 'admin',
                      'badge-success': profile.role === 'manager',
                      'badge-secondary': profile.role === 'salesRep',
                    }"
                  >
                    {{
                      profile.role === "admin"
                        ? "Administrador"
                        : profile.role === "manager"
                          ? "Administrador"
                          : profile.role === "salesRep"
                            ? "Vendedor"
                            : "N/A"
                    }}
                  </span>
                </td>
                <td>
                  {{
                    new Date(
                      profile.createdAt._seconds * 1000 +
                        profile.createdAt._nanoseconds / 1000000,
                    ).toLocaleDateString("es-ES", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    }) || "N/A"
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="mt-3">
          <small class="text-muted">
            Total: {{ companyProfiles.length }} usuario(s)
          </small>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        @click="showProfilesModal = false"
      >
        Cerrar
      </button>
    </div>
  </VueFinalModal>
</template>

<script>
/* eslint-disable */
import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net-bs5";
import "datatables.net-responsive";
import $ from "jquery";
import "vue-final-modal/style.css";
import { VueFinalModal } from "vue-final-modal";
import * as XLSX from "xlsx";

DataTable.use(DataTablesCore);

export default {
  name: "ListadoDistribuidores",
  components: {
    DataTable,
    VueFinalModal,
  },
  props: [],
  watch: {
    rucNumber(newVal, oldVal) {
      // Reset company info when RUC number changes
      if (newVal !== oldVal) {
        this.companyInfo = {
          companyName: "",
          address: "",
          city: null,
          phone: "",
          type: "",
          arpuTableId: this.defaultArpuTableId,
        };
      }
    },
  },
  computed: {
    isFormValid() {
      return (
        this.rucNumber &&
        this.companyInfo.companyName &&
        this.companyInfo.address &&
        this.companyInfo.city &&
        this.companyInfo.phone &&
        this.companyInfo.type &&
        this.companyInfo.city !== "null"
      );
    },
    isEditFormValid() {
      return (
        this.selectedDistributor.ruc &&
        this.selectedDistributor.companyName &&
        this.selectedDistributor.address &&
        this.selectedDistributor.city &&
        this.selectedDistributor.phone &&
        this.selectedDistributor.addedBy &&
        this.selectedDistributor.type &&
        this.selectedDistributor.city !== "null"
      );
    },
    isManagerFormValid() {
      const base = this.managerData.dni && this.managerData.lastnames;
      if (this.isEnterpriseDistributor) {
        return (
          base &&
          this.managerData.role &&
          this.managerData.branch &&
          this.managerData.branch.trim() !== "" &&
          this.managerData.phone &&
          this.managerData.phone.trim() !== ""
        );
      }
      return base;
    },
    isEnterpriseDistributor() {
      return this.selectedDistributorInfo && this.selectedDistributorInfo.type === "enterprise";
    },
  },
  data() {
    return {
      loading: true,
      distributors: [],
      filteredDistributors: [],
      addedByFilter: "",
      statusFilter: "",
      notAllow: false,
      userId: this.$store.state.user.userId,
      tokenAuth: this.$store.state.tokenAuth,
      loadingRuc: false,
      loadingDni: false,
      loadingDistributorDetails: false,
      showEditModal: false,
      showManagerModal: false,
      showProfilesModal: false,
      loadingProfiles: false,
      companyProfiles: [],
      selectedCompanyInfo: {
        companyId: null,
        companyName: "",
        profileCount: 0,
      },
      arpuTables: [],
      defaultArpuTableId: "",
      selectedDistributor: {
        companyId: null,
        companyName: "",
        ruc: "",
        address: "",
        city: null,
        phone: "",
        addedBy: "",
        type: "",
        arpuTableId: "",
      },
      selectedDistributorInfo: null,
      managerBranchesList: [],
      managerCitiesList: [],
      managerData: {
        dni: "",
        names: "",
        lastnames: "",
        namesList: [],
        lastnamesList: [],
        companyId: null,
        companyName: "",
        role: "salesRep",
        branch: "",
        phone: "",
        city: "",
      },
      columns: [
        {
          data: null,
          render: function (data, type, row) {
            if (data.createdAt && data.createdAt._seconds) {
              return new Date(
                data.createdAt._seconds * 1000 +
                  data.createdAt._nanoseconds / 1000000,
              ).toLocaleDateString("es-ES", {
                year: "numeric",
                month: "short",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              });
            }
            return "N/A";
          },
        },
        { data: "companyName" },
        { data: "ruc" },
        {
          data: "address",
          render: function (data, type, row) {
            if (data && data.length > 30) {
              return data.substring(0, 30) + "...";
            }
            return data || "N/A";
          },
        },
        { data: "city" },
        { data: "phone" },
        {
          data: "type",
          render: function (data, type, row) {
            if (!data) return "N/A";
            return data === "promoter"
              ? "Promotor"
              : data === "enterprise"
                ? "Cadena de Tiendas"
                : data;
          },
        },
        // {
        //   data: "totalSales",
        //   render: function (data, type, row) {
        //     return `<span class="text-success" style="font-weight: bold">${data}</span>`;
        //   },
        // },
        {
          data: null,
          render: function (data, type, row) {
            return data.addedBy || "PlanPro";
          },
        },
        {
          data: null,
          render: function (data) {
            return data.arpuTableName || "Tabla estándar";
          },
        },
        {
          data: null,
          render: function (data, type, row) {
            return `
              <button type="button" class="btn btn-info btn-sm view-profiles" 
                style="display:flex; align-items:center; gap:5px" 
                data-id="${data.companyId}"
                data-name="${data.companyName}"
                data-count="${data.profileCount || 0}">
                <i class="fas fa-users"></i> ${data.profileCount || 0}
              </button>
            `;
          },
        },
        {
          data: null,
          render: function (data, type, row) {
            const isActive = data.isActive;
            const salesCount = data.monthlySalesCount || 0;
            const statusIcon = isActive ? "fa-circle" : "fa-circle";
            const statusText = isActive ? "Activo" : "Inactivo";

            return `
              <div style="display: flex; align-items: center; gap: 8px;">
                <i class="fas ${statusIcon}" style="font-size: 12px; color: ${isActive ? "#28a745" : "#dc3545"};"></i>
                <span style="font-size: 12px; font-weight: bold; color: ${isActive ? "#28a745" : "#dc3545"};">
                  ${statusText}
                </span>
                ${isActive ? `<span class="badge badge-success" style="font-size: 10px;">${salesCount}</span>` : ""}
              </div>
            `;
          },
        },
        {
          data: null,
          render: function (data, type, row) {
            return `
              <div class="btn-group">
                <button type="button" class="btn btn-primary btn-sm edit-distributor" 
                  style="display:flex; align-items:center; gap:5px; padding: 0.5rem 1rem !important" 
                  data-id="${data.companyId}"
                  data-ruc="${data.ruc}"
                  data-name="${data.companyName}"
                  data-address="${data.address}"
                  data-city="${data.city}"
                  data-phone="${data.phone}"
                  data-addedby="${data.addedBy || "PlanPro"}"
                  data-type="${data.type || ""}">
                  Editar <i style="margin-left: 5px" class="fas fa-edit"></i>
                </button>
                <button type="button" class="btn btn-primary btn-sm add-distributor-manager" 
                  style="display:flex; align-items:center; gap:5px; padding: 0.5rem 1rem !important" 
                  data-id="${data.companyId}">
                  Admin <i style="margin-left: 5px" class="fas fa-crown"></i>
                </button>
              </div>
            `;
          },
        },
      ],
      options: {
        responsive: true,
        ordering: false,
        columnDefs: [
          { responsivePriority: 1, targets: 1 }, // Company name
          { responsivePriority: 2, targets: -1 }, // Actions
          { responsivePriority: 3, targets: 0 }, // Creation date
        ],
        lengthMenu: [
          [7, 15, 25, 35, 50, -1],
          [7, 15, 25, 35, 50, "All"],
        ],
        pageLength: 7,
        language: {
          search: "Buscar:",
          sInfo:
            "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          sInfoEmpty:
            "Mostrando registros del 0 al 0 de un total de 0 registros",
          searchPlaceholder: "Buscar por término...",
          zeroRecords: "Lo sentimos, no se encontraron resultados",
          processing: "Buscando. Espere por favor...",
          sLengthMenu: "Mostrar _MENU_ registros",
          oPaginate: {
            sFirst: "Primero",
            sLast: "Último",
            sNext: "Siguiente",
            sPrevious: "Anterior",
          },
          infoFiltered: " - filtrados de _MAX_ registros",
        },
      },
      showAddModal: false,
      rucNumber: "",
      companyInfo: {
        companyName: "",
        address: "",
        city: null,
        phone: "",
        type: "",
        arpuTableId: "",
      },
      cities: [
        "Guayaquil",
        "Quito",
        "Cuenca",
        "Loja",
        "Santo Domingo",
        "Ambato",
        "Ibarra",
        "Portoviejo",
        "Riobamba",
        "Quevedo",
        "Latacunga",
        "Duran",
        "Pasaje",
        "Salinas",
        "La Libertad",
        "Azogues",
        "Manta",
        "Santa Rosa",
        "Babahoyo",
        "Tulcan",
        "Otavalo",
        "Montecristi",
        "Chone",
        "Cayambe",
        "Gualaceo",
        "Salcedo",
        "El Guabo",
        "Atuntaqui",
        "Huaquillas",
        "Piñas",
        "Cañar",
        "Machala",
        "Catamayo",
        "Jaramijo",
        "Cotacachi",
        "Arenillas",
        "Portovelo",
        "Calceta",
        "Alausi",
        "Tosagua",
        "Flavio Alfaro",
        "Camilo Ponce Enriquez",
        "Zaruma",
        "Balsas",
        "Chunchi",
        "Junin",
        "Cevallos",
        "Guamote",
        "Chaguarpamba",
        "Esmeraldas",
        "El Carmen",
      ],
    };
  },
  mounted() {
    this.fetchArpuTables();
    this.fetchDistributors();

    // Event listeners for edit and delete buttons
    $(document).on("click", ".edit-distributor", (evt) => {
      const button = $(evt.currentTarget);
      const distributorFromList = this.distributors.find(
        (d) => d.companyId === button.data("id"),
      );

      this.selectedDistributor = {
        companyId: button.data("id"),
        ruc: button.data("ruc"),
        companyName: button.data("name"),
        address: button.data("address"),
        city: button.data("city"),
        phone: button.data("phone"),
        addedBy: button.data("addedby"),
        type: button.data("type") || "",
        arpuTableId:
          distributorFromList?.arpuTableId || this.defaultArpuTableId,
      };

      this.editDistribuidor(button.data("id"));
    });

    $(document).on("click", ".add-distributor-manager", (evt) => {
      evt.stopPropagation();
      const id = $(evt.currentTarget).data("id");
      this.addDistributorManager(id);
    });

    $(document).on("click", ".view-profiles", (evt) => {
      evt.stopPropagation();
      const button = $(evt.currentTarget);
      const companyId = button.data("id");
      const companyName = button.data("name");
      const profileCount = button.data("count");
      this.viewCompanyProfiles(companyId, companyName, profileCount);
    });
  },
  methods: {
    refresh() {
      this.fetchDistributors();
    },

    downloadExcel() {
      if (this.filteredDistributors.length === 0) {
        this.$toast.warning("No hay datos para exportar", {
          position: "top-right",
          max: 10,
        });
        return;
      }

      // Prepare data for Excel export
      const excelData = this.filteredDistributors.map((distributor) => {
        const createdAt =
          distributor.createdAt && distributor.createdAt._seconds
            ? new Date(
                distributor.createdAt._seconds * 1000 +
                  distributor.createdAt._nanoseconds / 1000000,
              ).toLocaleDateString("es-ES", {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              })
            : "N/A";

        const typeLabel =
          distributor.type === "promoter"
            ? "Promotor"
            : distributor.type === "enterprise"
              ? "Cadena de Tiendas"
              : distributor.type || "N/A";

        return {
          "Fecha de Creación": createdAt,
          Empresa: distributor.companyName || "N/A",
          RUC: distributor.ruc || "N/A",
          Dirección: distributor.address || "N/A",
          Ciudad: distributor.city || "N/A",
          Teléfono: distributor.phone || "N/A",
          Tipo: typeLabel,
          "Agregado por": distributor.addedBy || "PlanPro",
          Usuarios: distributor.profileCount || 0,
          Estado: distributor.isActive ? "Activo" : "Inactivo",
          "Ventas del Mes": distributor.monthlySalesCount || 0,
        };
      });

      // Create workbook and worksheet
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(excelData);

      // Set column widths
      const colWidths = [
        { wch: 20 }, // Fecha de Creación
        { wch: 30 }, // Empresa
        { wch: 15 }, // RUC
        { wch: 40 }, // Dirección
        { wch: 20 }, // Ciudad
        { wch: 15 }, // Teléfono
        { wch: 20 }, // Tipo
        { wch: 20 }, // Agregado por
        { wch: 10 }, // Usuarios
        { wch: 10 }, // Estado
        { wch: 15 }, // Ventas del Mes
      ];
      ws["!cols"] = colWidths;

      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(wb, ws, "Distribuidores");

      // Generate filename with current date and filters
      const currentDate = new Date()
        .toLocaleDateString("es-ES")
        .replace(/\//g, "-");
      let filename = `Distribuidores_${currentDate}`;

      if (this.addedByFilter) {
        filename += `_${this.addedByFilter.replace(/\s+/g, "_")}`;
      }

      if (this.statusFilter) {
        filename += `_${this.statusFilter === "active" ? "Activos" : "Inactivos"}`;
      }

      filename += ".xlsx";

      // Save file
      XLSX.writeFile(wb, filename);

      this.$toast.success(`Archivo Excel descargado: ${filename}`, {
        position: "top-right",
        max: 10,
      });
    },

    applyFilter() {
      this.filteredDistributors = this.distributors
        .filter((distributor) => {
          // Filter by addedBy
          const addedByMatch =
            !this.addedByFilter ||
            (distributor.addedBy || "PlanPro") === this.addedByFilter;

          // Filter by status
          const statusMatch =
            !this.statusFilter ||
            (this.statusFilter === "active" && distributor.isActive) ||
            (this.statusFilter === "inactive" && !distributor.isActive);

          return addedByMatch && statusMatch;
        })
        .sort((a, b) => {
          // Sort by creation date (newest first)
          const dateA =
            a.createdAt && a.createdAt._seconds
              ? new Date(
                  a.createdAt._seconds * 1000 +
                    a.createdAt._nanoseconds / 1000000,
                )
              : new Date(0);
          const dateB =
            b.createdAt && b.createdAt._seconds
              ? new Date(
                  b.createdAt._seconds * 1000 +
                    b.createdAt._nanoseconds / 1000000,
                )
              : new Date(0);

          return dateB - dateA; // Newest first
        });
    },

    viewCompanyProfiles(companyId, companyName, profileCount) {
      this.selectedCompanyInfo = {
        companyId,
        companyName,
        profileCount,
      };
      this.showProfilesModal = true;
      this.loadingProfiles = true;
      this.companyProfiles = [];

      this.$https
        .post("/administration/fetchUsersByCompany/", {
          tokenAuth: this.tokenAuth,
          userId: this.userId,
          companyId: companyId,
        })
        .then((response) => {
          this.loadingProfiles = false;
          this.companyProfiles = response.data.users || [];
        })
        .catch((error) => {
          this.loadingProfiles = false;
          this.$toast.error(
            error.response?.data?.message || "Error al cargar los perfiles",
            {
              position: "top-right",
              max: 10,
            },
          );
        });
    },

    fetchArpuTables() {
      this.$https
        .post("/administration/fetchArpuTables", {
          tokenAuth: this.tokenAuth,
          userId: this.userId,
        })
        .then((response) => {
          this.arpuTables = response.data.tables || [];
          const defaultTable = this.arpuTables.find((t) => t.isDefault);
          this.defaultArpuTableId = defaultTable?.id || this.arpuTables[0]?.id || "";
          if (!this.companyInfo.arpuTableId) {
            this.companyInfo.arpuTableId = this.defaultArpuTableId;
          }
        })
        .catch(() => {
          this.arpuTables = [];
        });
    },

    fetchDistributors() {
      console.log({
        tokenAuth: this.tokenAuth,
        userId: this.userId,
      });
      this.$https
        .post("/administration/fetchDistributorsWithMonthlySales/", {
          tokenAuth: this.tokenAuth,
          userId: this.userId,
        })
        .then((response) => {
          this.loading = false;
          this.notAllow = false;
          // Sort distributors by creation date (newest first) when loading
          this.distributors = response.data.distributors.sort((a, b) => {
            const dateA =
              a.createdAt && a.createdAt._seconds
                ? new Date(
                    a.createdAt._seconds * 1000 +
                      a.createdAt._nanoseconds / 1000000,
                  )
                : new Date(0);
            const dateB =
              b.createdAt && b.createdAt._seconds
                ? new Date(
                    b.createdAt._seconds * 1000 +
                      b.createdAt._nanoseconds / 1000000,
                  )
                : new Date(0);

            return dateB - dateA; // Newest first
          });
          this.applyFilter();
        })
        .catch((error) => {
          if (error.status === 401) {
            this.$store.dispatch("clearAllData");
            this.$toast.error(error.response.data.message, {
              position: "top-right",
              max: 10,
            });
            this.$router.push({ name: "Signin" });
          } else if (error.status === 403) {
            this.loading = false;
            this.$router.push({ name: "Dashboard" });
            this.$toast.error("Acceso no autorizado", {
              position: "top-right",
              max: 10,
            });
          } else {
            this.$toast.error(error.response.data.message, {
              position: "top-right",
              max: 10,
            });
          }
        });
    },

    editDistribuidor(id) {
      // Instead of searching in distributors or fetching from server,
      // get all data from the button data attributes directly
      this.showEditModal = true;
      this.loadingDistributorDetails = false;
    },

    fetchDistributorDetails(id) {
      this.loadingDistributorDetails = true;
      this.showEditModal = true;

      // Find distributor in existing data first to show immediately
      const distributorFromList = this.distributors.find(
        (distributor) => distributor.companyId === id,
      );

      if (distributorFromList) {
        this.selectedDistributor = { ...distributorFromList };
        this.loadingDistributorDetails = false;
      } else {
        // If not in list (or need fresh data), fetch from server
        this.$https
          .post("/administration/fetchDistributorDetails/", {
            tokenAuth: this.tokenAuth,
            userId: this.userId,
            companyId: id,
          })
          .then((response) => {
            this.selectedDistributor = response.data.distributor;
            this.loadingDistributorDetails = false;
          })
          .catch((error) => {
            this.loadingDistributorDetails = false;
            this.$toast.error(
              error.response?.data?.message ||
                "Error al cargar los datos del distribuidor",
              {
                position: "top-right",
                max: 10,
              },
            );
          });
      }
    },

    updateDistributor() {
      if (!this.selectedDistributor) return;

      this.loading = true;

      // First update the basic distributor info
      this.$https
        .post("/administration/updateDistributor/", {
          tokenAuth: this.tokenAuth,
          userId: this.userId,
          companyId: this.selectedDistributor.companyId,
          city: this.selectedDistributor.city,
          phone: this.selectedDistributor.phone,
          addedBy: this.selectedDistributor.addedBy,
          type: this.selectedDistributor.type,
          arpuTableId: this.selectedDistributor.arpuTableId,
        })
        .then((response) => {
          this.loading = false;
          this.showEditModal = false;
          this.$toast.success("Distribuidor actualizado exitosamente", {
            position: "top-right",
            max: 10,
          });
          this.fetchDistributors();
        })
        .catch((error) => {
          this.loading = false;
          this.$toast.error(
            error.response?.data?.message || "Error al actualizar distribuidor",
            {
              position: "top-right",
              max: 10,
            },
          );
        });
    },

    addDistributorManager(id) {
      const distributor = this.distributors.find((d) => d.companyId === id);

      if (distributor) {
        this.selectedDistributorInfo = distributor;
        this.managerData = {
          dni: "",
          names: "",
          lastnames: "",
          namesList: [],
          lastnamesList: [],
          companyId: id,
          companyName: distributor.companyName || "",
          role: "salesRep",
          branch: "",
          phone: "",
          city: "",
        };
        this.managerBranchesList = [];
        this.managerCitiesList = [];
        this.showManagerModal = true;
        if (distributor.type === "enterprise") {
          this.fetchManagerBranches(id);
          this.fetchManagerCities(id);
        }
      } else {
        this.$toast.error("No se encontró información del distribuidor", {
          position: "top-right",
          max: 10,
        });
      }
    },
    fetchManagerBranches(companyId) {
      this.$https
        .post("administration/getBranchesForCompany", {
          tokenAuth: this.tokenAuth,
          userId: this.userId,
          companyId,
        })
        .then((res) => {
          this.managerBranchesList = res.data.branches || [];
        })
        .catch(() => {
          this.managerBranchesList = [];
        });
    },
    fetchManagerCities(companyId) {
      this.$https
        .post("administration/getCitiesForCompany", {
          tokenAuth: this.tokenAuth,
          userId: this.userId,
          companyId,
        })
        .then((res) => {
          this.managerCitiesList = res.data.cities || [];
        })
        .catch(() => {
          this.managerCitiesList = [];
        });
    },
    managerRoleLabel(role) {
      const labels = {
        director: "Jefe (Director)",
        supervisor: "Supervisor",
        manager: "Manager",
        salesRep: "Vendedor (SalesRep)",
      };
      return labels[role] || role;
    },

    splitSpanishName(fullName) {
      if (!fullName || typeof fullName !== "string") {
        return {
          lastnames: "",
          names: "",
          lastnamesList: [],
          namesList: [],
        };
      }

      const particles = ["DE", "LA", "DEL", "LAS", "LOS", "SAN", "SANTA"]; // List of particles in uppercase
      const nameParts = fullName
        .trim()
        .split(/\s+/)
        .filter((part) => part.length > 0); // Split the name into individual words and filter empty strings

      // Handle edge case: if there are only 2 strings, first is lastname, second is name
      if (nameParts.length === 2) {
        return {
          lastnames: nameParts[0],
          names: nameParts[1],
          lastnamesList: [nameParts[0]],
          namesList: [nameParts[1]],
        };
      }

      // Handle edge case: if there's only 1 string, treat it as a lastname
      if (nameParts.length === 1) {
        return {
          lastnames: nameParts[0],
          names: "",
          lastnamesList: [nameParts[0]],
          namesList: [],
        };
      }

      let lastnames = []; // This will hold the lastnames
      let names = []; // This will hold the names
      let tempList = []; // Temporary list to hold current group of words
      let i = 0;
      let lastnamesNumber = 0;

      // Handle first part for lastnames (grouping particles and first last name)
      while (lastnamesNumber < 2 && i < nameParts.length) {
        while (i < nameParts.length) {
          const currentWord = nameParts[i].toUpperCase();
          if (particles.includes(currentWord)) {
            // If it's a particle, add to tempList
            tempList.push(nameParts[i]); // Use original case
            i++;
          } else {
            // Stop when a non-particle word is encountered
            tempList.push(nameParts[i]);
            lastnames.push(tempList.join(" ")); // Save lastnames
            tempList = []; // Reset tempList for next part
            i++; // Move to the next word
            break; // Stop the loop for lastnames part
          }
        }
        lastnamesNumber++;
      }

      // Handle second part for names (grouping the remaining names)
      while (i < nameParts.length) {
        const currentWord = nameParts[i].toUpperCase();

        if (particles.includes(currentWord)) {
          // If it's a particle, add to tempList
          tempList.push(nameParts[i]); // Use original case
          i++;
        } else {
          // Otherwise, add word to names
          tempList.push(nameParts[i]);
          names.push(tempList.join(" ")); // Save names
          tempList = []; // Reset tempList for next part
          i++;
        }
      }

      // Return the split result: first part is lastnames, second part is names
      return {
        lastnames: lastnames.join(" "), // Join all parts for lastnames
        names: names.join(" "), // Join all parts for names
        lastnamesList: lastnames,
        namesList: names,
      };
    },

    fetchPersonByDni() {
      if (!this.managerData.dni) return;

      this.loadingDni = true;

      if (this.isEnterpriseDistributor && this.managerData.companyId) {
        this.$https
          .post("administration/getProfileByDniForCompany", {
            tokenAuth: this.tokenAuth,
            userId: this.userId,
            companyId: this.managerData.companyId,
            dni: this.managerData.dni.trim(),
          })
          .then((res) => {
            if (res.data.data) {
              const d = res.data.data;
              this.managerData.names = d.names || "";
              this.managerData.lastnames = d.lastnames || "";
              this.managerData.phone = d.phone || "";
              if (d.branch) this.managerData.branch = d.branch;
              if (d.role) this.managerData.role = d.role;
              if (d.city) this.managerData.city = d.city;
              this.managerData.namesList = (d.names || "").split(/\s+/).filter(Boolean);
              this.managerData.lastnamesList = (d.lastnames || "").split(/\s+/).filter(Boolean);
            }
            if (!res.data.data || (!this.managerData.names && !this.managerData.lastnames)) {
              this.fetchManagerDniDataOnly();
            } else {
              this.loadingDni = false;
            }
          })
          .catch(() => {
            this.fetchManagerDniDataOnly();
          });
        return;
      }

      this.fetchManagerDniDataOnly();
    },
    fetchManagerDniDataOnly() {
      this.$https
        .post("/administration/fetchDniData", {
          dni: this.managerData.dni,
        })
        .then((response) => {
          const nombres = response.data.dataGeneral?.nombres;

          if (nombres && typeof nombres === "string") {
            const { names, lastnames, namesList, lastnamesList } =
              this.splitSpanishName(nombres);
            this.managerData.names = names;
            this.managerData.lastnames = lastnames;
            this.managerData.namesList = namesList;
            this.managerData.lastnamesList = lastnamesList;
          } else {
            this.managerData.names =
              response.data.dataGeneral?.nombre ||
              response.data.dataGeneral?.nombres ||
              "";
            this.managerData.lastnames =
              response.data.dataGeneral?.apellido ||
              response.data.dataGeneral?.apellidos ||
              "";
            this.managerData.namesList = this.managerData.names
              ? [this.managerData.names]
              : [];
            this.managerData.lastnamesList = this.managerData.lastnames
              ? [this.managerData.lastnames]
              : [];
          }
          this.loadingDni = false;
        })
        .catch((error) => {
          this.loadingDni = false;
          this.$toast.error(
            error.response?.data?.message || "Error al validar DNI",
            { position: "top-right", max: 10 },
          );
        });
    },

    saveDistributorManager() {
      if (!this.isManagerFormValid) return;

      this.loading = true;

      if (this.isEnterpriseDistributor) {
        const userData = {
          dni: this.managerData.dni,
          names: this.managerData.names,
          lastnames: this.managerData.lastnames,
          namesList: this.managerData.namesList || [],
          lastnamesList: this.managerData.lastnamesList || [],
          role: this.managerData.role,
          branch: this.managerData.branch,
          companyId: this.managerData.companyId,
          companyName: this.managerData.companyName,
          phone: this.managerData.phone || "",
          city: this.managerData.city || "",
        };
        this.$https
          .post("/administration/addSalesRepresentative/", {
            tokenAuth: this.tokenAuth,
            userId: this.userId,
            userData,
          })
          .then((response) => {
            this.loading = false;
            this.showManagerModal = false;
            this.$toast.success(
              response.data?.message || "Usuario agregado correctamente",
              { position: "top-right", max: 10 }
            );
          })
          .catch((error) => {
            this.loading = false;
            this.$toast.error(
              error.response?.data?.message || "Error al agregar usuario",
              { position: "top-right", max: 10 },
            );
          });
        return;
      }

      this.$https
        .post("/administration/addDistributorManager/", {
          tokenAuth: this.tokenAuth,
          userId: this.userId,
          managerData: this.managerData,
        })
        .then(() => {
          this.loading = false;
          this.showManagerModal = false;
          this.$toast.success("Administrador agregado exitosamente", {
            position: "top-right",
            max: 10,
          });
        })
        .catch((error) => {
          this.loading = false;
          this.$toast.error(
            error.response?.data?.message || "Error al agregar administrador",
            { position: "top-right", max: 10 },
          );
        });
    },

    addDistributor() {
      this.showAddModal = true;
      this.rucNumber = "";
      this.companyInfo = {
        companyName: "",
        address: "",
        city: null,
        phone: "",
        type: "",
        arpuTableId: this.defaultArpuTableId,
      };
    },

    softDeleteDistributor(companyId, companyName) {
      // Show confirmation dialog
      this.$swal({
        title: "¿Estás seguro?",
        text: `¿Deseas eliminar el distribuidor "${companyName}"? Esta acción no se puede deshacer e impedirá que los usuarios de esta empresa accedan al sistema.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true;

          this.$https
            .post("/administration/softDeleteDistributor/", {
              tokenAuth: this.tokenAuth,
              userId: this.userId,
              companyId: companyId,
            })
            .then((response) => {
              this.loading = false;
              this.showEditModal = false;
              this.$toast.success("Distribuidor eliminado exitosamente", {
                position: "top-right",
                max: 10,
              });
              this.fetchDistributors();
            })
            .catch((error) => {
              this.loading = false;
              this.$toast.error(
                error.response?.data?.message ||
                  "Error al eliminar distribuidor",
                {
                  position: "top-right",
                  max: 10,
                },
              );
            });
        }
      });
    },

    fetchCompanyByRuc() {
      if (!this.rucNumber) return;

      this.loadingRuc = true;
      this.$https
        .post("/administration/fetchCompanyByRuc/", {
          tokenAuth: this.tokenAuth,
          userId: this.userId,
          ruc: this.rucNumber,
        })
        .then((response) => {
          console.log("Response data:", response.data);

          // Handle new data structure
          const contribuyente = response.data.data.contribuyente;
          const establecimientos = response.data.data.establecimientos;

          if (contribuyente && contribuyente.length > 0) {
            this.companyInfo = {
              ...this.companyInfo,
              companyName: contribuyente[0].razonSocial,
            };

            // Find the main establishment (matriz)
            if (establecimientos && establecimientos.length > 0) {
              const mainEstablishment = establecimientos.find(
                (est) => est.matriz === "SI",
              );
              if (mainEstablishment) {
                this.companyInfo.address = mainEstablishment.direccionCompleta;
              }
            }

            console.log("Updated companyInfo:", this.companyInfo);
          } else {
            this.$toast.error("No se encontró información para este RUC", {
              position: "top-right",
              max: 10,
            });
          }

          this.loadingRuc = false;
        })
        .catch((error) => {
          this.loadingRuc = false;

          // Handle different types of errors
          if (error.response) {
            const status = error.response.status;
            const message =
              error.response.data?.message || "Error al validar RUC";

            if (status === 503) {
              // Service unavailable
              this.$toast.error(
                "El servicio de consulta de RUC no está disponible. Por favor, inténtelo más tarde.",
                {
                  position: "top-right",
                  max: 10,
                  duration: 8000,
                },
              );
            } else if (status === 504) {
              // Gateway timeout
              this.$toast.error(
                "El servicio de consulta de RUC no responde. Por favor, inténtelo más tarde.",
                {
                  position: "top-right",
                  max: 10,
                  duration: 8000,
                },
              );
            } else {
              this.$toast.error(message, {
                position: "top-right",
                max: 10,
              });
            }
          } else if (error.request) {
            // Network error
            this.$toast.error(
              "Error de conexión. Verifique su conexión a internet e inténtelo nuevamente.",
              {
                position: "top-right",
                max: 10,
                duration: 8000,
              },
            );
          } else {
            // Other errors
            this.$toast.error("Error inesperado al consultar RUC", {
              position: "top-right",
              max: 10,
            });
          }
        });
    },

    saveDistributor() {
      if (!this.companyInfo) return;

      this.loading = true;
      this.$https
        .post("/administration/saveDistributor/", {
          tokenAuth: this.tokenAuth,
          userId: this.userId,
          distributorData: { ...this.companyInfo, ruc: this.rucNumber },
        })
        .then((response) => {
          this.loading = false;
          this.showAddModal = false;
          this.$toast.success("Distribuidor agregado exitosamente", {
            position: "top-right",
            max: 10,
          });
          this.fetchDistributors();
        })
        .catch((error) => {
          this.loading = false;
          this.$toast.error(
            error.response?.data?.message || "Error al guardar distribuidor",
            {
              position: "top-right",
              max: 10,
            },
          );
        });
    },
  },
};
</script>

<style lang="scss">
@import "datatables.net-dt";
@import "datatables.net-responsive-dt";

.btn-group {
  display: flex;
  gap: 5px;
}

.badge {
  padding: 0.5em 0.75em;
  font-size: 0.75em;
}

.modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  margin: 0 1rem;
  padding: 1rem;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
}

.modal-content-profiles {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  margin: 0 1rem;
  padding: 1rem;
  border-radius: 0.25rem;
  background: #fff;
  width: 900px;
  font-size: 0.875rem;
}

.modal-content-profiles .table {
  font-size: 0.8rem;
  margin-bottom: 0;
}

.modal-content-profiles .table th,
.modal-content-profiles .table td {
  padding: 0.5rem 0.75rem;
  vertical-align: middle;
}

.modal-content-profiles .badge {
  font-size: 0.7rem;
  padding: 0.25rem 0.5rem;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1rem 0 1rem;
}

.modal-body {
  padding: 0 1rem 1rem 1rem;
  overflow-y: auto;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  //   border-top: 1px solid #e2e8f0;
  padding: 0 1rem 1rem 1rem;
}

.company-info {
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 0.25rem;

  .info-item {
    margin-bottom: 0.5rem;
  }
}
</style>
